import { z } from "zod";
/**
 * Modèle de rareté (WEBAPI_SPEC W11).
 * `Rarity` enum (Etheria_Items) : COMMUN..UNIQUE, ordinal 0-6, statMultiplier croissant.
 */
/** Ordre exact = ordinal 0-6 (ne pas réordonner : l'ordinal est persisté en DB). */
export const RARITIES = [
    "COMMUN",
    "PEU_COMMUN",
    "RARE",
    "EPIQUE",
    "LEGENDAIRE",
    "MYTHIQUE",
    "UNIQUE",
];
export const RaritySchema = z.enum(RARITIES);
/** Ordinal 0-6 tel que persisté (colonne `rarity INT`). */
export const RarityOrdinalSchema = z.number().int().min(0).max(6);
/** Rareté embarquée dans un item sérialisé (§7.4) : {ordinal, label}. */
export const RarityRefSchema = z.object({
    ordinal: RarityOrdinalSchema,
    label: RaritySchema,
});
/** Libellés FR d'affichage par rareté. */
export const RARITY_LABEL_FR = {
    COMMUN: "Commun",
    PEU_COMMUN: "Peu commun",
    RARE: "Rare",
    EPIQUE: "Épique",
    LEGENDAIRE: "Légendaire",
    MYTHIQUE: "Mythique",
    UNIQUE: "Unique",
};
/** Couleur (hex) par rareté — palette steampunk pour badges/bordures. */
export const RARITY_COLOR = {
    COMMUN: "#9aa0a6",
    PEU_COMMUN: "#4caf50",
    RARE: "#3b82f6",
    EPIQUE: "#a855f7",
    LEGENDAIRE: "#f59e0b",
    MYTHIQUE: "#ef4444",
    UNIQUE: "#14b8a6",
};
/** Multiplicateur de stats par rareté (miroir de Rarity.statMultiplier). */
export const RARITY_STAT_MULTIPLIER = {
    COMMUN: 1.0,
    PEU_COMMUN: 1.1,
    RARE: 1.25,
    EPIQUE: 1.5,
    LEGENDAIRE: 1.8,
    MYTHIQUE: 2.2,
    UNIQUE: 2.6,
};
export function rarityFromOrdinal(ordinal) {
    return RARITIES[Math.max(0, Math.min(6, ordinal))];
}
// ── Loot / probabilités (WEBAPI_SPEC §5 — dumps wiki avec loot%) ──────────────
/**
 * Chance de drop réutilisable. `chancePct` est un pourcentage 0-100.
 * `perGrade` module la chance par déclinaison/grade (ex tier de nœud, difficulté).
 * ALLOWLIST anti-glitch : uniquement des % descriptifs, jamais de seed RNG interne.
 */
export const DropChanceSchema = z.object({
    chancePct: z.number().min(0).max(100),
    perGrade: z.record(z.string(), z.number().min(0).max(100)).optional(),
    note: z.string().optional(),
});
/**
 * Distribution de rareté : rareté → pourcentage (somme ≈ 100).
 * Sert aux tables de loot (ex répartition des raretés d'un roll de donjon/mob).
 */
export const RarityDistributionSchema = z.record(RaritySchema, z.number().min(0).max(100));
//# sourceMappingURL=rarity.js.map